"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetBridgeSettingsHook = void 0;
var ethers_1 = require("ethers");
var react_1 = require("react");
function useSetBridgeSettingsHook(homeBridge) {
    var _this = this;
    var _a = __read((0, react_1.useState)(), 2), bridgeFee = _a[0], setBridgeFee = _a[1];
    var _b = __read((0, react_1.useState)(undefined), 2), relayerThreshold = _b[0], setRelayerThreshold = _b[1];
    (0, react_1.useEffect)(function () {
        var getRelayerThreshold = function () { return __awaiter(_this, void 0, void 0, function () {
            var threshold, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!homeBridge) return [3 /*break*/, 2];
                        _b = (_a = ethers_1.BigNumber).from;
                        return [4 /*yield*/, homeBridge._relayerThreshold()];
                    case 1:
                        threshold = _b.apply(_a, [_c.sent()]).toNumber();
                        setRelayerThreshold(threshold);
                        _c.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        var getBridgeFee = function () { return __awaiter(_this, void 0, void 0, function () {
            var bridgeFee_1, _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!homeBridge) return [3 /*break*/, 2];
                        _a = Number;
                        _c = (_b = ethers_1.utils).formatEther;
                        return [4 /*yield*/, homeBridge._fee()];
                    case 1:
                        bridgeFee_1 = _a.apply(void 0, [_c.apply(_b, [_d.sent()])]);
                        setBridgeFee(bridgeFee_1);
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getRelayerThreshold();
        getBridgeFee();
    }, [homeBridge]);
    return [bridgeFee, relayerThreshold];
}
exports.useSetBridgeSettingsHook = useSetBridgeSettingsHook;
//# sourceMappingURL=useSetBridgeSettingsHook.js.map